export enum ChargeType {
  TICKET = 'TICKET',
}
